import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useDispatch ,useSelector } from 'react-redux';
import { apiUrl } from "../../config/Config";

const UpdateUsers = ({ isOpen, onClose, onSave, userdata }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata1 = useSelector((store) => store.userReducer.userdata);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [number, setNumber] = useState('');
    const [role, setRole] = useState('admin');
    const [password, setPassword] = useState('');
    const [retypePassword, setRetypePassword] = useState('');
    const [showLoading, setShowLoading] = useState(false);

    const roles = ['admin', 'superadmin'];

    const validatePassword = (password) => password.length >= 6;

    const handleSubmitUser = async () => {
        if (password && password !== retypePassword) {
            Swal.fire({
                text: 'Password and retype password do not match!',
                icon: 'error',
                width: '350px',
                confirmButtonText: 'Ok',
                confirmButtonColor: "rgb(59, 151, 196)",
                customClass: { popup: "small-icon-alert" },
            });
            return;
        }

        if (password && !validatePassword(password)) {
            Swal.fire({
                text: 'Password must be at least 6 characters.',
                icon: 'error',
                width: '350px',
                confirmButtonText: 'Ok',
                confirmButtonColor: "rgb(59, 151, 196)",
                customClass: { popup: "small-icon-alert" },
            });
            return;
        }

        setShowLoading(true);

        const data = {
            userid: userdata?.userid,
            firstname: firstName,
            lastname: lastName,
            email,
            mobile: number,
            type: role,
            username: email,
            password,
            retypepassword: retypePassword,
            status: 'true',
        };

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userdata1?.token}`,
            }
        };

        try {
           
            const res = await axios.post(apiUrl + 'updateuseraccount',data, headers);
            if (res.data.status === 'success') {
                Swal.fire({
                    text: 'User updated successfully!',
                    icon: 'success',
                    width: '350px',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: "rgb(59, 151, 196)",
                    customClass: { popup: "small-icon-alert" },
                });
                onSave();
            } else if (res.data.message === 'invalid user') {
                dispatch({ type: "userdata", payload: {} });
                navigate('/');
            } else {
                Swal.fire({
                    text: res.data.message,
                    icon: 'error',
                    width: '350px',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: "rgb(59, 151, 196)",
                    customClass: { popup: "small-icon-alert" },
                });
            }
        } catch (err) {
            alert(err.message);
        } finally {
            setShowLoading(false);
        }
    };

    useEffect(() => {
        if (userdata) {
            setFirstName(userdata.firstname || '');
            setLastName(userdata.lastname || '');
            setEmail(userdata.email || '');
            setNumber(userdata.mobile || '');
            setRole(userdata.type || 'admin');
        }
    }, [userdata]);

    if (!isOpen) return null;

    return (
        <div className="user-modal-overlay">
            <div className="user-modal-container">
                <div className="user-modal-header">
                    <h2 className='createpost-modal-title'>Update Internal User</h2>
                    <button onClick={onClose} className="user-modal-close-btn">
                        <X size={20} />
                    </button>
                </div>

                <form className="user-modal-form" onSubmit={(e) => e.preventDefault()}>
                    <div className="user-modal-group">
                        <div className="user-modal-field">
                            <label>First Name</label>
                            <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required />
                        </div>
                        <div className="user-modal-field">
                            <label>Last Name</label>
                            <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} required />
                        </div>
                    </div>

                    <div className="user-modal-field">
                        <label>Email</label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                    </div>

                    <div className="user-modal-field">
                        <label>Phone Number</label>
                        <input type="text" value={number} onChange={e => setNumber(e.target.value)} required />
                    </div>

                    <div className="user-modal-field">
                        <label>Role</label>
                        <select value={role} onChange={e => setRole(e.target.value)}>
                            {roles.map(r => <option key={r} value={r}>{r}</option>)}
                        </select>
                    </div>

                    <div className="user-modal-group">
                        <div className="user-modal-field">
                            <label>Password</label>
                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
                        </div>
                        <div className="user-modal-field">
                            <label>Retype Password</label>
                            <input type="password" value={retypePassword} onChange={e => setRetypePassword(e.target.value)} />
                        </div>
                    </div>

                    <div className="user-modal-footer">
                        <button type="button" className="user-modal-cancel" onClick={onClose} disabled={showLoading}>Cancel</button>
                        <button type="submit" className="user-modal-submit" onClick={handleSubmitUser} disabled={showLoading}>
                            {showLoading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateUsers;
